<template>
	<div class="knd-paragraaf swiper-no-swiping" v-html="data.content">
	</div>
</template>

<script>

	const vueObject = {
		props: ['data'],
		mounted: function() {},
		methods: {}
	}

	export default vueObject;
</script>